import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { Handle, Position } from '@xyflow/react';
import { Box, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const NodePaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    minWidth: 200,
    backgroundColor: '#ffffff',
    border: `2px solid ${theme.palette.black['100']}`,
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[3],
    '&:hover': {
      boxShadow: theme.shadows[6],
    }
  }));
  
  const StyledHandle = styled(Handle)(({ theme }) => ({
    width: 10,
    height: 10,
    backgroundColor: "black",
    border: "white",
  }));

export function FollowUpEmailNode() {
  return (
    <NodePaper elevation={3}>
      <StyledHandle
        type="target"
        position={Position.Top}
        isConnectable={true}
      />
      
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        gap: 1,
        py: 1 
      }}>
        <ForwardToInboxIcon color="primary" />
        <Typography variant="subtitle1" color="primary">
          Send Follow-up
        </Typography>
      </Box>

      <StyledHandle
        type="source"
        position={Position.Bottom}
        id="b"
        isConnectable={true}
      />
    </NodePaper>
  );
}